import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';
import { ICrumb } from '../../types';
import { HomeIcon } from '../../assets/svg';
import './styles.scss';

export interface INavigation {
  crumbs: ICrumb[];
  additionalCrumbs?: ICrumb[];
  baseUrl: string;
  homeUrl: string;
  isRouter?: boolean;
}

const Navigation: FC<INavigation> = ({ crumbs, additionalCrumbs, baseUrl, homeUrl, isRouter = true }) => {
  if (crumbs.length === 0) {
    return null;
  }

  return (
    <section className='hbh-navigation'>
      {crumbs.map(({ name, path }, key) =>
        !name?.length ? (
          <a className={cn('hbh-item', 'icon')} href={homeUrl} key={key}>
            <HomeIcon />
          </a>
        ) : key + 1 === crumbs.length ? (
          <div key={key} className={cn('hbh-item', 'last')}>
            {name}
          </div>
        ) : isRouter ? (
          <Link key={key} className='hbh-item' to={`${baseUrl}${path}`}>
            {name}
          </Link>
        ) : (
          <a key={key} className='hbh-item' href={`${baseUrl}${path}`}>
            {name}
          </a>
        )
      )}
      {additionalCrumbs?.length
        ? additionalCrumbs.map(({ name, path }, key) =>
            isRouter ? (
              <Link key={key} className='hbh-item' to={`${baseUrl}${path}`}>
                {name}
              </Link>
            ) : (
              <a key={key} className='hbh-item' href={`${baseUrl}${path}`}>
                {name}
              </a>
            )
          )
        : null}
    </section>
  );
};

export default Navigation;
